import React, { useEffect, useRef, useState } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import Label from "./LabelF";
import Axios from "axios";
import { farmageo_api } from "../../../../../config";
import { useRefStore } from "../../../../..";
import { refrescar } from "../../../context/PantallaReducer";
import {
  aplicarOpcionDefaultAFiltros,
  buscarOpcionDefault,
  buscarOpcionPorValor,
  componerOpcionesSelect,
  debeActualizarOpcionesFiltro,
  normalizarValorFiltroParaSelect,
  opcionEsTodas,
  reconciliarOpcionesSelect,
  opcionEstaDeshabilitada,
} from "../../../helper/opcionesFiltros";

export const SelectF = (props) => {
  const [store, setStore] = useRefStore();
  const [configuraciones_ref] = useRefStore((s) => s.configuraciones_ref);
  let {
    id_a,
    filtrosAAplicar,
    setFiltrosAAplicar,
    aplicarFiltroValorActivo,
    opciones: op,
    select_es_maestro,
    select_depende_de,
    select_todas,
    select_maestro_de,
    setOpElegida,
    componente,
    filtro_actualizar_opciones,
    sincronizarFiltrosDesdeBack,
  } = props;

  select_todas = select_todas !== "n";

  const [opciones, setOpciones] = useState(() =>
    componerOpcionesSelect(op, select_todas)
  );
  const [loading, setLoading] = useState(false);
  const [valor, setValor] = useState(() =>
    normalizarValorFiltroParaSelect(filtrosAAplicar[id_a], select_todas)
  );
  const valorRef = useRef(valor);
  const opcionesRef = useRef(opciones);
  const sincronizarFiltros =
    sincronizarFiltrosDesdeBack ?? setFiltrosAAplicar;

  useEffect(() => {
    valorRef.current = valor;
  }, [valor]);

  useEffect(() => {
    opcionesRef.current = opciones;
  }, [opciones]);

  useEffect(() => {
    if (
      !debeActualizarOpcionesFiltro({
        componente,
        filtro_actualizar_opciones,
      })
    ) {
      return;
    }

    const opcionesActualizadas = reconciliarOpcionesSelect({
      opcionesNuevas: op,
      opcionesAnteriores: opcionesRef.current,
      valorSeleccionado: valorRef.current,
      incluirTodas: select_todas,
    });
    const opcionDefault = buscarOpcionDefault(opcionesActualizadas);

    setOpciones(opcionesActualizadas);

    if (opcionDefault) {
      setValor(isNumeric(opcionDefault.value));
      sincronizarFiltros((filtros) =>
        aplicarOpcionDefaultAFiltros({
          filtros,
          id_a,
          clave_envio: props.clave_envio,
          opcionDefault,
        })
      );
    }

    const opcionElegidaActualizada =
      opcionDefault ??
      buscarOpcionPorValor(opcionesActualizadas, valorRef.current);

    if (opcionElegidaActualizada && setOpElegida) {
      setOpElegida((opcionesElegidas) => {
        if (opcionEsTodas(opcionElegidaActualizada)) {
          const opcionesActualizadas = { ...opcionesElegidas };
          delete opcionesActualizadas[id_a];
          return opcionesActualizadas;
        }

        if (
          opcionEstaDeshabilitada(opcionElegidaActualizada) ||
          (!opcionDefault && !opcionesElegidas?.[id_a])
        ) {
          return opcionesElegidas;
        }

        return {
          ...opcionesElegidas,
          [id_a]: opcionElegidaActualizada,
        };
      });
    }
  }, [
    componente,
    filtro_actualizar_opciones,
    id_a,
    op,
    props.clave_envio,
    select_todas,
    sincronizarFiltros,
    setOpElegida,
  ]);

  const f = filtrosAAplicar[select_depende_de];

  useEffect(() => {
    if (configuraciones_ref[id_a] === 1) return;
    setLoading(() => true);

    Axios.post(farmageo_api + "/select/opciones", {
      [id_a]: filtrosAAplicar[select_depende_de],
    }).then((res) => {
      const opcionesActualizadas = componerOpcionesSelect(
        Array.isArray(res.data) ? res.data : [],
        select_todas
      );
      const opcionDefault = buscarOpcionDefault(opcionesActualizadas);

      setOpciones(opcionesActualizadas);

      if (opcionDefault) {
        setValor(isNumeric(opcionDefault.value));
        sincronizarFiltros((filtros) =>
          aplicarOpcionDefaultAFiltros({
            filtros,
            id_a,
            clave_envio: props.clave_envio,
            opcionDefault,
          })
        );

        if (!opcionEstaDeshabilitada(opcionDefault) && setOpElegida) {
          setOpElegida((opcionesElegidas) => {
            const opcionesActualizadas = { ...opcionesElegidas };
            if (opcionEsTodas(opcionDefault)) {
              delete opcionesActualizadas[id_a];
            } else {
              opcionesActualizadas[id_a] = opcionDefault;
            }
            return opcionesActualizadas;
          });
        }
      }

      setLoading(false);
    });
  }, [configuraciones_ref[id_a]]);

  const handleChange = (valor) => {
    setValor(isNumeric(valor));
    aplicarFiltroValorActivo(valor);
    const op = buscarOpcionPorValor(opciones, valor);
    if (setOpElegida) {
      setOpElegida((prev) => {
        const opcionesElegidas = { ...prev };
        if (opcionEsTodas(op)) {
          delete opcionesElegidas[id_a];
        } else {
          opcionesElegidas[id_a] = op;
        }
        return opcionesElegidas;
      });
    }
    if (
      select_es_maestro === "s" &&
      select_maestro_de &&
      select_maestro_de.trim() !== ""
    ) {
      select_maestro_de.split(",").forEach((ida) => {
        setStore({ configuraciones_ref: refrescar(store, ida.trim(), [3, 4]) });
      });
      return;
    }
  };

  useEffect(() => {
    if (!f) return; // select maestro existe o esta definido
    if (select_depende_de) {
      sincronizarFiltros((prevState) => {
        const nuevosFiltros = { ...prevState };
        delete nuevosFiltros[id_a];
        if (props.clave_envio) delete nuevosFiltros[props.clave_envio];
        return nuevosFiltros;
      });
      setOpciones(componerOpcionesSelect([], select_todas));
    }
  }, [f, select_depende_de]);

  useEffect(() => {
    const valorAplicado = filtrosAAplicar[id_a];
    const incluyeTodas = opciones.some(opcionEsTodas);
    setValor(
      isNumeric(
        normalizarValorFiltroParaSelect(valorAplicado, incluyeTodas)
      )
    );
  }, [filtrosAAplicar, id_a, opciones]);

  return (
    <div className="filtroSelect">
      <FormControl fullWidth>
        <Label
          label={props.label}
          opcionales_null={props.opcionales_null}
          permite_null={props.permite_null}
        />
        {loading ? (
          <></>
        ) : (
          <Select
            style={{ width: "100%", height: "32px", fontSize: "0.8rem" }}
            variant="standard"
            onChange={(e) => {
              handleChange(e.target.value);
            }}
            value={valor} //{isNumeric(filtrosAAplicar[id_a])}
            error={props.error[id_a]}
            disabled={
              select_depende_de &&
              select_depende_de.trim() !== "" &&
              !f &&
              select_es_maestro !== "s"
            }
          >
            {opciones &&
              opciones.map((opcion) => {
                return (
                  <MenuItem
                    sx={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "0.8rem",
                    }}
                    value={opcion.value}
                    key={opcion.value + opcion.label}
                    className="select_option"
                    disabled={opcion.disabled}
                  >
                    {opcion.default ? <em>{opcion.label}</em> : opcion.label}
                  </MenuItem>
                );
              })}
          </Select>
        )}
      </FormControl>
    </div>
  );
};

export default SelectF;

function isNumeric(value) {
  // Si el valor es un número, no es necesario convertirlo
  if (typeof value === "number") {
    return value;
  }
  if (!value) return value;

  // Convertir el valor a un string
  value = String(value);

  // Crear una expresión regular para validar los caracteres numéricos
  const regex = /^[0-9]+$/;

  // Devolver el valor si es válido
  if (regex.test(value)) {
    return Number(value);
  }

  // Devolver un string vacío si es inválido
  return value;
}
